<template>
  <div>
    <el-dialog
      :visible.sync="selfShow"
      width="1510px"
      :title="popupTitle"
      :close-on-click-modal="false"
      append-to-body
      @close="popupCancel"
    >
      <div v-if="isLoad" class="page-main">
        <div class="page-l">
          <DetailNav :module.sync="module" />
        </div>
        <div class="page-r">
          <keep-alive>
            <component
              :is="`Cont${module}`"
              :id.sync="billId"
              @success="popupCancel"
              @jump="jumpModule"
            />
          </keep-alive>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    DetailNav: () => import('./detail-nav'),
    ContVerify: () => import('./cont-verify'),
    ContMade: () => import('./cont-made')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    billId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isLoad: false,
      selfShow: false,
      module: 'Made',
      bill_code: '',
      xie_tong_status_str: ''
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    accountId() {
      return this.$store.state.loginAccount.id
    },
    popupTitle() {
      let type = '委外加工'
      let code = this.bill_code
      let status = this.xie_tong_status_str
      let result = `${type}(${code})-${status}`
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getDetailData()
  },
  methods: {
    jumpModule(val) {
      this.module = val
    },
    // 获取-详情数据
    getDetailData() {
      this.isLoad = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong3/detail',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.bill_code = result.formData.bill_code
          this.xie_tong_status_str = result.formData.xie_tong_status_str
          this.isLoad = true
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('success')
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  position: relative;
  display: flex;
  flex: 1;
  .page-l {
    margin-right: 10px;
  }
  .page-r {
    flex: 1;
  }
}
</style>
